import React from 'react';
import { HomeIcon, BuildingIcon, FactoryIcon, ClipboardCheckIcon } from 'lucide-react';
const Services = () => {
  return <section id="services" className="bg-gray-50 py-16" data-id="element-342">
      <div className="container mx-auto px-4" data-id="element-343">
        <div className="text-center mb-12" data-id="element-344">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-345">
            Our EICR Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-346">
            We provide comprehensive Electrical Installation Condition Reports
            for all property types, ensuring compliance with the latest UK
            regulations.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-347">
          {/* Residential EICR */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-348">
            <div className="p-6" data-id="element-349">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-350">
                <HomeIcon className="w-7 h-7 text-blue-600" data-id="element-351" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-352">
                Residential EICR
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-353">
                Comprehensive electrical safety inspections for homeowners and
                landlords, ensuring your property meets all safety standards.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-354">
                <li className="flex items-center text-gray-600" data-id="element-355">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-356" />
                  <span data-id="element-357">Private homes</span>
                </li>
                <li className="flex items-center text-gray-600" data-id="element-358">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-359" />
                  <span data-id="element-360">Rental properties</span>
                </li>
                <li className="flex items-center text-gray-600" data-id="element-361">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-362" />
                  <span data-id="element-363">HMO properties</span>
                </li>
              </ul>
              <a href="#contact" className="block text-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors" data-id="element-364">
                Book Now
              </a>
            </div>
          </div>
          {/* Commercial EICR */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-365">
            <div className="p-6" data-id="element-366">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-367">
                <BuildingIcon className="w-7 h-7 text-blue-600" data-id="element-368" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-369">
                Commercial EICR
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-370">
                Ensure your business premises comply with workplace safety
                regulations with our thorough commercial EICR service.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-371">
                <li className="flex items-center text-gray-600" data-id="element-372">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-373" />
                  <span data-id="element-374">Office buildings</span>
                </li>
                <li className="flex items-center text-gray-600" data-id="element-375">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-376" />
                  <span data-id="element-377">Retail premises</span>
                </li>
                <li className="flex items-center text-gray-600" data-id="element-378">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-379" />
                  <span data-id="element-380">Restaurants & cafes</span>
                </li>
              </ul>
              <a href="#contact" className="block text-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors" data-id="element-381">
                Book Now
              </a>
            </div>
          </div>
          {/* Industrial EICR */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-382">
            <div className="p-6" data-id="element-383">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-384">
                <FactoryIcon className="w-7 h-7 text-blue-600" data-id="element-385" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-386">
                Industrial EICR
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-387">
                Specialized electrical safety inspections for industrial
                facilities with complex electrical installations.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-388">
                <li className="flex items-center text-gray-600" data-id="element-389">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-390" />
                  <span data-id="element-391">Factories & warehouses</span>
                </li>
                <li className="flex items-center text-gray-600" data-id="element-392">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-393" />
                  <span data-id="element-394">Manufacturing facilities</span>
                </li>
                <li className="flex items-center text-gray-600" data-id="element-395">
                  <ClipboardCheckIcon className="w-5 h-5 mr-2 text-blue-600" data-id="element-396" />
                  <span data-id="element-397">Industrial complexes</span>
                </li>
              </ul>
              <a href="#contact" className="block text-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors" data-id="element-398">
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Services;